<template lang="pug">
.c-staffs-editor
  form-frame(:title="title"
    :fetching="fetching"
    :fn="submit"
    @cancel="existDialog = true"
    @succeed-confirm="$router.push({ name: 'cms' })")
    v-container(fluid)
      v-layout
        v-dialog(v-model="sortDialog"
          max-width="300")
          template(v-slot:activator="{ on }")
            v-btn(color="info"
              flat
              outline
              v-on="on") 編輯排序
          v-card
            v-list
              dnd(v-model="items"
                :style="{ width: '100%' }")
                template(v-for="(item, index) in items")
                  v-list-tile
                    v-list-tile-title {{ index + 1 }}
                    v-list-tile-title {{ item.name }}
      v-layout
        v-flex
          v-data-table(
            :headers="headers"
            :items="items"
            :rows-per-page-items="[{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
            disable-initial-sort
            expand)
            template(v-slot:items="props")
              td {{ props.index + 1 }}
              td.text-xs-center
                v-btn(
                  color="warning"
                  flat
                  small
                  icon
                  @click="openForm(props.index)")
                  v-icon edit
              td {{ props.item.name }}
              td {{ props.item.job }}
              td {{ props.item.telNumber }}
              td {{ props.item.phoneNumber }}
              td {{ props.item.email }}
              td {{ props.item.address }}
              td {{ props.item.career }}
              td {{ props.item.homeland }}
      v-layout
        v-btn(color="info"
          flat
          outline
          @click="addItem") 新增人員
    v-dialog(v-model="formDialog" max-width="400")
      v-card.pa-3(v-if="formDialog")
        v-container
          v-layout
            v-btn(:ripple="false"
              icon
              flat
              @click.stop="openCropper(edittingIndex)")
              base-url-provider(:filepath="$u.get(items[edittingIndex], 'photo.name')")
                template(v-slot="{ url }")
                  v-avatar.mx-1(size="32")
                    img(:src="$u.get(items[edittingIndex], 'temp.dataURL') || url || defUser")
          v-layout(wrap)
            v-flex.px-2(xs12
              md6)
              v-text-field(v-model="items[edittingIndex].name"
                :error-messages="getNameErrors(edittingIndex)"
                label="姓名"
                required)
            v-flex.px-2(xs12
              md6)
              v-text-field(v-model="items[edittingIndex].job"
                label="職稱")
            v-flex.px-2(xs12
              md6)
              v-text-field(v-model="items[edittingIndex].address"
                label="地址")
            v-flex.px-2(xs12
              md6)
              v-text-field(v-model="items[edittingIndex].telNumber"
                label="電話")
            v-flex.px-2(xs12
              md6)
              v-text-field(v-model="items[edittingIndex].phoneNumber"
                label="手機")
            v-flex.px-2(xs12
              md6)
              v-text-field(v-model="items[edittingIndex].email"
                label="電子信箱")
            v-flex.px-2(xs12
              md6)
              v-text-field(v-model="items[edittingIndex].career"
                label="職業")
            v-flex.px-2(xs12
              md6)
              v-text-field(v-model="items[edittingIndex].homeland"
                label="家鄉")
            v-flex.px-2(xs12)
              v-btn(color="error"
                outline
                flat
                @click="removeItem(edittingIndex)") 刪除
    v-dialog(v-model="cropper.actived")
      base-url-provider(:filepath="$u.get(items[cropper.itemIndex], 'photo.name')")
        template(v-slot="{ url }")
          cropper-card(ref="cropper"
            v-if="cropper.actived"
            :progress="cropper.progress"
            :source="$u.get(items[cropper.itemIndex], 'temp.dataURL') || url"
            :cropper="cropper.cropper"
            @crop="updateImage")
    v-dialog(v-model="exitDialog"
      max-width="290")
      v-card
        v-card-title.headline 您確定要離開？
        v-card-text 尚未儲存的資料、照片將會遺失。
        v-card-actions
          v-btn(color="info"
            flat
            outline
            @click="existDialog = false") 返回
          v-btn(color="error"
            flat
            outline
            @click="$router.push({ name: 'cms' })") 確定離開
    check-dialog(:open="alert" :title="alertMessage" @check="alertMessage = ''; alert = false")
</template>

<script>
import { mapActions } from "vuex";
import uniqid from "uniqid";
import Dnd from "vuedraggable";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import camelCase from "lodash/camelCase";
import { db, storage } from "@/firebase";
import FormFrame from "@/components/core/FormFrame.vue";
import StaffForm from "@/components/forms/StaffForm.vue";
import CropperCard from "@/components/CropperCard.vue";
import BaseUrlProvider from "@/components/core/BaseUrlProvider.vue";
import CheckDialog from "@/components/core/CheckDialog.vue";
import defUser from "@/assets/images/user-default.jpg";

export default {
  name: "StaffEditor",
  mixins: [validationMixin],
  validations: {
    items: {
      required,
      $each: {
        name: { required }
      }
    }
  },
  components: {
    FormFrame,
    StaffForm,
    Dnd,
    CropperCard,
    BaseUrlProvider,
    CheckDialog
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      headers: [
        { text: "排序", value: "order", sortable: false },
        { text: "編輯", value: "edit", sortable: false },
        { text: "姓名", value: "name", sortable: false },
        { text: "職稱", value: "job", sortable: false },
        { text: "電話", value: "telNumber", sortable: false },
        { text: "手機", value: "phoneNumber", sortable: false },
        { text: "email", value: "email", sortable: false },
        { text: "地址", value: "address", sortable: false },
        { text: "職業", value: "career", sortable: false },
        { text: "故鄉", value: "homeland", sortable: false }
      ],
      defUser,
      defItem: {
        name: "",
        job: "",
        address: "",
        telNumber: "",
        phoneNumber: "",
        email: "",
        career: "",
        homeland: ""
      },
      cropper: {
        actived: false,
        itemIndex: null,
        progress: null,
        cropper: {
          stencilProps: {
            aspectRatio: 1 / 1
          }
        }
      },
      fetching: true,
      items: [],
      exitDialog: false,
      counter: 0,
      formDialog: false,
      edittingIndex: null,
      sortDialog: false,
      alert: false,
      alertMessage: ""
    };
  },
  async created() {
    await this.fetchData();
    this.fetching = false;
  },
  methods: {
    ...mapActions(["api"]),
    openForm(index) {
      this.edittingIndex = index;
      this.formDialog = true;
    },
    openCropper(index) {
      this.cropper.actived = true;
      this.cropper.itemIndex = index;
      this.formDialog = false;
    },
    closeCropper() {
      this.cropper.actived = false;
      this.cropper.itemIndex = null;
      this.formDialog = true;
    },
    updateImage({ canvas }) {
      const dataURL = canvas.toDataURL();
      this.$utils.set(
        this.items[this.cropper.itemIndex],
        "temp.dataURL",
        dataURL
      );

      canvas.toBlob(blob => {
        this.$utils.set(
          this.items[this.cropper.itemIndex],
          "temp.photoBlob",
          blob
        );
        this.closeCropper();
      });
    },
    async uploadStaffPhoto(item) {
      const filename = uniqid();
      const filepath = `images/staffs/${this.id}/${filename}.jpg`;
      const ref = storage.ref().child(filepath);

      const blob = item.temp.photoBlob;

      await ref.put(blob, {
        contentType: "image/jpeg",
        customMetadata: {
          converted: false
        }
      });

      item.photo = { name: filepath };
      delete item.temp;
    },
    async uploadImages() {
      const updateList = [];
      this.items.forEach(item => {
        if (this.$u.get(item, "temp.photoBlob")) {
          updateList.push(this.uploadStaffPhoto(item));
        }
      });

      await Promise.all(updateList);
    },
    addItem() {
      if (!this.items) this.items = [];

      this.items.push(Object.assign({}, this.defItem));
    },
    removeItem(index) {
      this.formDialog = false;
      this.items.splice(index, 1);
    },
    getNameErrors(index) {
      const errors = [];
      if (!this.$v.items.$each[index].$dirty) return errors;
      !this.$v.items.$each[index].name.required && errors.push("請填入姓名");
      return errors;
    },
    async fetchData() {
      const doc = await db
        .collection("staffs")
        .doc(this.id)
        .get();

      if (!doc.exists) {
        this.items = [];
        this.fetching = false;
        return;
      }
      let { items } = doc.data();

      this.items = items || [];
      this.fetching = false;
    },
    async submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        const items = this.$v.items.$each.$iter;
        let msg = "以下姓名未填：";

        for (let i in items) {
          if (items[i].$invalid) {
            const order = parseInt(i) + 1;
            msg += ` ${order}`;
          }
        }

        this.alertMessage = msg;
        this.alert = true;
        return false;
      }

      await this.uploadImages();
      return this.api({
        method: "put",
        url: `staffs/${this.id}`,
        data: { items: this.items }
      });
    }
  }
};
</script>
